export enum PANEL_HEIGHT {
  CONTENT = 741,
  SETTINGS = 250,
  VARIANT_SETUP = 350,
}
